import Main from '@/views/administracion/ejecucion/Main.vue';
import Default from '@/views/administracion/ejecucion/Default.vue';
import MainContrato from '@/views/administracion/ejecucion/contrato/Main.vue';
import MainAnticipos from '@/views/administracion/contratos/contrato/anticipos/Main.vue';
import DefaultContratoEjecucion from '@/views/administracion/contratos/contrato/Default.vue';
import MainContratoReporteFisico from '@/views/administracion/ejecucion/contrato/reportes/Main.vue';
import MainEstimaciones from '@/views/administracion/ejecucion/contrato/estimaciones/Default.vue';
import MainCatalogo from '@/views/administracion/contratos/contrato/catalogo/Main.vue';
import MainPrograma from '@/views/administracion/contratos/contrato/programa/Main.vue';
import MainGraficaComparativaAvances from '@/views/administracion/ejecucion/contrato/graficacomparativaavances/Main.vue';
import MainGraficaAvanceFisico from '@/views/administracion/reportes/contrato/graficaavancefisico/Main.vue';
import MainActividades from '@/views/administracion/ejecucion/contrato/actividades/Main.vue';
import MainExpediente from '@/views/administracion/ejecucion/contrato/expediente/Main.vue';
import MainAlbum from '@/views/administracion/ejecucion/contrato/album/Main.vue';
import MainAlbumFrentes from '@/views/administracion/ejecucion/contrato/albumfrentes/Main.vue';
import MainEstadisticas from '@/views/administracion/ejecucion/estadisticas/Main.vue';
import MainContratoFechas from '@/views/administracion/ejecucion/contrato/fechas/Main.vue';
import MainContratoGarantias from '@/views/administracion/ejecucion/contrato/garantias/Main.vue';
import MainAvanceReal from '@/views/administracion/contratos/contrato/avancereal/Main.vue';
import MainContratoFrentes from '@/views/administracion/contratos/contrato/frentes/Main.vue';
import MainContratoReporteActividades from '@/views/administracion/ejecucion/contrato/reporteactividades/Main.vue';
import MainContratoInventrios from '@/views/administracion/ejecucion/contrato/inventario/Main.vue';
import MainContratoCatalogoFavoritos from '@/views/administracion/ejecucion/contrato/catalogofavoritos/Default.vue';
import MainContratoVideos from '@/views/administracion/contratos/contrato/contratovideos/Main.vue';
import Configuracion from './configuracion';

const auth = ['Supervisión:ver'];
const scopes = ['Supervisión:crear', 'Supervisión:editar', 'Supervisión:eliminar'];

const ejecucion = [
  {
    path: 'ejecucion',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'contratoEjecucionEstadisticas',
        path: 'estadisticas',
        meta: {
          title: 'Ejecucion Estadisticas',
          auth,
          scopes,
        },
        component: MainEstadisticas,

        children: [],
      },
      ...Configuracion,
      {
        name: 'ejecucion',
        path: '/',
        meta: {
          title: 'Ejecución',
          auth,
          scopes,
        },
        component: Default,
        children: [],
      },
      {
        path: ':idContrato',
        meta: {
          title: 'Contrato',
          auth,
          scopes,
        },
        component: MainContrato,
        children: [
          {
            name: 'contratoEjecucionGenerales',
            path: '/',
            meta: {
              title: 'Generales',
              auth,
              scopes,
            },
            component: DefaultContratoEjecucion,
          },
          {
            name: 'contratoEjecucionReportes',
            path: 'reportes',
            meta: {
              title: 'Contrato',
              auth,
              scopes,
            },
            component: MainContratoReporteFisico,
          },
          {
            name: 'contratoAlbum',
            path: 'album',
            meta: {
              title: 'Album Fotográfico',
              auth,
              scopes,
            },
            component: MainAlbum,
          },
          {
            name: 'contratoEjecucionAlbumFrentes',
            path: 'albumfrentes',
            meta: {
              title: 'Album Fotográfico',
              auth,
              scopes,
            },
            component: MainAlbumFrentes,
            /*
            props: {
              modulo: 'ejecucion',
            }, */
          },
          {
            name: 'contratoEjecucionAnticipos',
            path: 'anticipos',
            meta: {
              title: 'Anticipos',
              auth,
              scopes,
            },
            props: {
              soloLectura: true,
            },
            component: MainAnticipos,
          },
          {
            name: 'contratoEjecucionCatalogo',
            path: 'catalogo',
            meta: {
              title: 'Catálogo',
              auth,
              scopes,
            },
            props: {
              soloLectura: true,
            },
            component: MainCatalogo,
          },
          {
            name: 'contratoEjecucionPrograma',
            path: 'programa',
            meta: {
              title: 'Contrato',
              auth,
              scopes,
            },
            component: MainPrograma,
            props: {
              soloLectura: true,
            },
          },
          {
            name: 'contratoEjecucionEstimaciones',
            path: 'estimaciones',
            meta: {
              title: 'Contrato',
              auth,
              scopes,
            },
            component: MainEstimaciones,
            props: {
              soloLectura: true,
            },
          },
          {
            path: 'grafica-comparativa',
            name: 'contratoGraficaComparativaAvances',
            meta: {
              title: 'Gráfica Comparativa',
              auth,
              scopes,
            },
            component: MainGraficaComparativaAvances,
          },
          {
            path: 'grafica-avance-fisico',
            name: 'contratoEjecucionGraficaAvanceFisico',
            meta: {
              title: 'Gráfica',
              auth,
              scopes,
            },
            component: MainGraficaAvanceFisico,
          },
          {
            path: 'actividades',
            name: 'contratoEjecucionActividades',
            meta: {
              title: 'Actividades',
              auth,
              scopes,
            },
            component: MainActividades,
          },
          {
            name: 'contratoEjecucionExpediente',
            path: 'expediente',
            meta: {
              title: 'Expediente',
              auth,
              scopes,
            },
            component: MainExpediente,
          },
          {
            name: 'contratoFechas',
            path: 'fechas',
            meta: {
              title: 'Contratos fechas',
              auth,
              scopes,
            },
            component: MainContratoFechas,
          },
          {
            name: 'contratoGarantias',
            path: 'garantias',
            meta: {
              title: 'Garantías',
              auth,
              scopes,
            },
            component: MainContratoGarantias,
          },
          {
            name: 'contratosAvanceReal',
            path: 'avancereal',
            meta: {
              title: 'Avance Real',
              auth,
              scopes,
            },
            component: MainAvanceReal,
          },
          {
            name: 'contratoFrentes',
            path: 'frentes',
            meta: {
              title: 'Frentes',
              auth,
              scopes,
            },
            component: MainContratoFrentes,
          },
          {
            name: 'contratoVideos',
            path: 'videos',
            meta: {
              title: 'Videos',
              auth,
              scopes,
            },
            component: MainContratoVideos,
          },
          {
            name: 'contratoReporteActividades',
            path: 'reporteactividades',
            meta: {
              title: 'Reporte actividades',
              auth,
              scopes,
            },
            component: MainContratoReporteActividades,
          },
          {
            name: 'contratoInventarios',
            path: 'inventario',
            meta: {
              title: 'Inventario',
              auth,
              scopes,
            },
            component: MainContratoInventrios,
          },
          {
            name: 'contratoActiviodadesPrincipales',
            path: 'actividadespricipales',
            meta: {
              title: 'Actividades principales',
              auth,
              scopes,
            },
            component: MainContratoCatalogoFavoritos,
          },
        ],
      },
    ],
  },
];

export default ejecucion;
